import React, {useState} from "react";
import styled from "styled-components";

const StyledTabs = styled.span`
  .tabs {
    display: flex;
  }

  .tab {
    justify-content: center;
    align-items: center;
    width: 100%;
    background: #ffffff;
    padding: 1em 0;
    border: 1px solid #E5E5E5;
    cursor: pointer;
  }

  .tab.active {
    background: #FDEBF1;
    font-weight: bold;
    color: #EC407A;
    border: 1px solid #EC407A;
    cursor: pointer;
  }

`;

const Tabs = (props) => {
    const {setThreatGuardFormData} = props;
    const [activeIndex, setActiveIndex] = useState(2);
    const checkActive = (index, className) => activeIndex === index ? className : "";
    const handleClick = (index,months) => {
        setActiveIndex(index);
        setThreatGuardFormData(prevState => {
            return {
                ...prevState,
                threadGuardDaysReducer: months * 30
            }
        });
    };


    return (
        <StyledTabs>
            <div className="tabs">
                <button
                    className={`tab ${checkActive(1, "active")}`}
                    onClick={() => handleClick(1,3)}
                    type={"button"}
                >
                    3 Months
                </button>
                <button
                    className={`tab ${checkActive(2, "active")}`}
                    onClick={() => handleClick(2,6)}
                    type={"button"}
                >
                    6 Months
                </button>
                <button
                    className={`tab ${checkActive(3, "active")}`}
                    onClick={() => handleClick(3,12)}
                    type={"button"}
                >
                    12 Months
                </button>
            </div>
        </StyledTabs>
    );
};

export default Tabs;
